import { FilledLinkToWebField } from '@prismicio/client';
import mixpanel from 'lib/analytics/mixpanel';

const DEFAULT_PAGE_CONTEXT = 'about-ted_click';

export const mixpanelClick = (
  pageContext = DEFAULT_PAGE_CONTEXT,
  eventContext: FilledLinkToWebField
): void => {
  if (!pageContext || !eventContext) return;

  mixpanel.track(pageContext, {
    event_interaction_context: eventContext.url
  });
};
